module.exports = __webpack_public_path__ + "img/cave166.38b49fd7.jpg";